import { Project } from '../types'
import roles from './roles'

const mentorship: Project[] = [
  {
    name: 'AWS Hackathon Winner',
    date: new Date('Dec 1 2018'),
    role: roles.gameChangerRole,
    slideIn: {
      externalLink: 'https://foghornconsulting.com/reinvent-hackathon-defending-the-title/',
      text: `Led team of volunteer developers to first place on a GameChanger project during the NPO Hackathon at AWS re:Invent.`
    }
    // projectKey: 'reInvent'
  },
  {
    name: 'UCI UX/UI Mentor',
    date: new Date('Feb 1 2018'),
    role: roles.gameChangerRole,
    slideIn: {
      externalLink: 'https://mhcid.ics.uci.edu/',
      text: `Mentored team of 6 Master students from start to finish of a 6-month design project.`
    }
  },
  {
    name: 'Lenovo Co+Lab',
    date: new Date('Jan 1 2017'),
    role: roles.gameChangerRole,
    slideIn: {
      externalLink: 'https://www.healthdesignby.us/colab', //https://mitechnews.com/featured/u-m-set-debut-lenovohealthdesignby-us-innovation-colab-test-vr-ar-motts-childrens-hospital/
      text: `Oversaw a team of 9 graduate and undergrad students on Tango & Phab 2 Pro AR prototypes.`
    }
    // projectKey: 'Lenovo'
  },

  {
    name: 'Juvenile Detention',
    date: new Date('Jan 1 2017'),
    role: roles.gameStartRole,
    slideIn: {
      externalLink: 'https://www.youtube.com/watch?v=nsRYD3vydis',
      text: `
      Designed curriculum, trained instructors, and taught weekly coding classes for at-risk youth for over 2 years.
      `
    }
    // projectKey: 'YAA'
  },
  {
    name: 'Digital Citizenship Curriculum',
    date: new Date('Aug 1 2016'),
    role: roles.gameStartRole,
    slideIn: {
      externalLink: 'https://docs.google.com/document/d/1twN1IkZyM2ZnOtp_3NWALu5CA_opaQZr58H-oJ5ti_E/edit?usp=sharing',
      text: `
      Designed curriculum, trained instructors, and taught classes on coding and digital citizenship for the Wolverine Pathways program at University of Michigan.
      `
    }
    // projectKey: 'THS'
  },
  {
    name: 'Hackathon Designer',
    date: new Date('Jun 1 2016'),
    role: roles.gameChangerRole,
    slideIn: {
      externalLink: 'https://www.a2healthhacks.org/about-a2h2/',
      text: `
      Consulted with an amazing team of 4 female founders without previous hackathon experience. 
      Facilitated visioning, event design, recruiting sponsors, and coached participating teams to launch their first event.
      `
    }
    // projectKey: 'A2H2'
  }
]
export default mentorship
